import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  templateUrl: './not-found.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPage {}
